import { z } from 'zod';

export const RefDesignations = z.object({
  code: z.string(),
  referential_id: z.string().uuid(),
  occupation_code: z.string(),
  name: z.string(),
  short_name: z.string(),
  executive_occupation: z.boolean(),
  regulated_occupation: z.boolean(),
  environmental_transition: z.boolean(),
  digital_transition: z.boolean(),
  classification: z.string().nullish(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type RefDesignationsT = z.infer<typeof RefDesignations>;

export const RefDesignationsInsert = RefDesignations.partial();

export type RefDesignationsInsertT = z.infer<typeof RefDesignationsInsert>;

export const RefDesignationsUpdate = RefDesignations.partial();

export type RefDesignationsUpdateT = z.infer<typeof RefDesignationsUpdate>;
